import React, { Component, PropTypes } from 'react';
import './Slider.css';

class Slider extends Component {

  render() {
    let sliderClass = 'slider';
    let sliderBallClass = 'slider__ball';
    if (this.props.isActive === false) {
      sliderClass = 'slider slider__off'
      sliderBallClass = 'slider__ball slider__ball--off';
    }
    return (
      <div onClick={this.props.handleClick} className={sliderClass}>
        <div className={sliderBallClass}></div>
      </div>
    );
  }
}

Slider.propTypes = {
  handleClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired
};

export default Slider;



/** WEBPACK FOOTER **
 ** ./src/components/Slider/index.js
 **/